import React from "react";
import styles from "./LandingPage.module.css";
import logo from "../../assets/images/logo.png";
import { ArrowRight, PlusCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function LandingPage() {
  return (
    <>
      <section
        id="Home"
        className="dark:bg-gray-900 font-tajawal py-12 min-h-max"
      >
        <div className="grid py-8 px-4 mx-auto max-w-screen-xl lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="place-self-center mx-auto lg:col-span-7 text-center">
            <p className="font-arabic mb-4 max-w-2xl text-4xl md:text-5xl xl:text-6xl text-gray-800">
              <img
                src="https://d8czg093l6apo.cloudfront.net/logo/logo.png"
                alt="logo"
                className="w-96 h-auto inline-block"
              />
            </p>
            <p className="mb-6 max-w-2xl font-light text-gray-800 lg:mb-8 md:text-lg lg:text-xl">
              Create your own personalized items or explore our curated
              collections.
            </p>
            <div className="flex flex-row justify-center items-center gap-4">
              <Link
                to="/products"
                className="explore-btn text-black px-8 py-3 rounded-lg transition-colors flex items-center gap-2"
              >
                Explore More
                <ArrowRight size={20} />
              </Link>

              <Link to="/custom">
                <button className="bg-nav text-black px-8 py-3 rounded-lg transition-transform transform hover:scale-110 flex items-center gap-2">
                  <PlusCircle size={20} />
                  Create Custom
                </button>
              </Link>
            </div>
          </div>
          <div className="hidden lg:mt-0 lg:col-span-5 lg:flex justify-center">
            <img src={logo} alt="mockup" />
          </div>
        </div>
      </section>
    </>
  );
}
